import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { FiCheck } from "react-icons/fi";
import axios from "axios";
import { baseURL } from "../axios/AxiosAut";

// const validationSchema = Yup.object({
//   company_name: Yup.string()
//     .min(1, "Too short!")
//     .max(30, "Too long!")
//     .required("Company name is required"),
//   company_description: Yup.string().max(100, "Too long!"),
//   city: Yup.string().required("Required!"),
//   state: Yup.string().required("Required!"),
//   postal_code: Yup.string().required("Required!"),
//   country: Yup.string().required("Required!"),
// });

function Pricing() {
  const [Pakages, setPakages] = useState<any[]>([]);


  const initialValues = {
    company_name: "",
    company_description: "",
    city: "",
    state: "",
    postal_code: "",
    country: "",
    is_billing_billing_address: true,
  };
  const onSubmit = (values, onSubmitProps) => {
  console.log("Form Data", values);
  };

  //pakges api
  useEffect(() => {
    axios
      .get(`${baseURL}company/get_packages/`)
      .then((res) => {
        console.log(res.data);
        setPakages(res.data);
      })
      .catch((error) => {});
    return () => {
      //cleanup
    };
  }, []);
  return (
    <div>
      <div className="container  w-4/5  mx-auto  px-4 my-28 ">
        <div className="md:grid md:grid-cols-2 gap-24 font-Montserrat">
          <div className="md:flex md:flex-col content-start  justify-items-start">
            <h2 className="text-blue-200 text-2xl font-bold">
              Get a price specifically for you
            </h2>
            <p>
              orem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
            </p>
          </div>
          <div className="md:flex md:flex-col content-start justify-items-start">
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            // validationSchema={validationSchema}
            // validateOnMount
          >
            <Form className="space-y-6">
                <Field name="description">
                  {(props) => {
                    const { field, form, meta } = props;
                    console.log("field", field);
                    return (
                      <div>
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Description"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    );
                  }}
                </Field>
                <div className="grid grid-cols-2 gap-10">
                <Field name="first_name">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <div className="mt-6">
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="First Name"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    );
                  }}
                </Field>
                <Field name="last_name">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <div className="my-6">
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Last Name"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    );
                  }}
                </Field>
                </div>
                <div className="grid grid-cols-2 gap-10">
                <Field name="job_title">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <div>
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Job Title"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    );
                  }}
                </Field>
             
                <Field name="phone_number">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <div>
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Phone Number"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    );
                  }}
                </Field>
                </div>
                <div className="grid grid-cols-2 gap-10">
                <Field name="company">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <div className="mt-6">
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Company"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    );
                  }}
                </Field>
              <Field name="company_size">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <div className="mt-6">
                    <input
                      {...field}
                      type="text"
                      {...(meta.touched && meta.error
                        ? {
                            className:
                              "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                          }
                        : {
                            className:
                              "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                          })}
                      placeholder="Company Size"
                    ></input>
                    {meta.touched && meta.error ? (
                      <label className="text-xs font-semibold font-Montserrat text-red-500">
                        <span className="ml-1">{meta.error}</span>
                      </label>
                    ) : null}
                  </div>
                  );
                }}
              </Field>
              </div>
              <Field>
                {(props) => {
                  const { field, form, meta } = props;
                  const { isSubmitting } = form;
                  return (
                    <>
                      {!isSubmitting ? (
                        <button
                          type="submit"
                         
                                className=
                                  " border-2 border-blue-200 hover:text-white text-xl font-Montserrat font-bold text-blue-200 flex-shrink  hover:bg-blue-100 place-content-center  rounded-sm px-4 py-2 flex flex-grow w-60 ml-60 "
                            
                                
                        >
                          Get Quote
                        </button>
                      ) : (
                        <button
                          disabled
                          className="font-Montserrat font-semibold flex-shrink bg-blue-200 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow"
                        >
                          <div className="flex items-center justify-center space-x-2 animate-pulse">
                            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                          </div>
                        </button>
                      )}
                    </>
                  );
                }}
              </Field>
            </Form>
          </Formik>
          </div>
        </div>
      </div>
      <div className="container  w-3/4  mx-auto  px-4 my-28">
        <div className="font-bold text-2xl flex content-center justify-center font-Montserrat">
          General Pricing
        </div>
        <div className="grid lg:grid-cols-3 gap-3 my-28 md:grid-cols-1">
          {Pakages.map((pkg, index) => (
            <div className="card-body w-72 " key={index}>
              <div className="md:flex md:flex-col content-start items-center justify-items-start">
                <h2 className="font-semibold mt-4 text-2xl">{pkg.package_type}</h2>
                <h1 className="text-blue-200">(min{pkg.minimum_users}User)</h1>
                <div className="flex items-center mt-2 ">
                  <h2 className="text-blue-200 text-3xl font-bold">
                    ${pkg.price_per_user}
                  </h2>
                  <h1>/user</h1>
                </div>
                <h1>Billed Monthly</h1>
              </div>
              {pkg.workforce_instruction_scheduling && (
                <div className="md:flex items-center justify-start px-2 mt-2">
                  <svg
                className="mr-4"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                  stroke="#26F32E"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                  fill="#26F32E"
                />
              </svg>
                  <h1>Work Force instruction scheduling</h1>
                </div>
              )}
              {pkg.management_of_training && (
                <div className="md:flex items-start justify-start px-2">
                  <svg
                className="mr-4"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                  stroke="#26F32E"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                  fill="#26F32E"
                />
              </svg>
                  <h2>Management of workfore Training</h2>
                </div>
              )}
              {pkg.training && (
                <div className="md:flex items-start justify-start px-2">
                  <svg
                className="mr-4"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                  stroke="#26F32E"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                  fill="#26F32E"
                />
              </svg>
                  <h1> Training</h1>
                </div>
              )}
              {pkg.quality_control && (
                <div className="md:flex items-start justify-start px-2">
                 <svg
                className="mr-4"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                  stroke="#26F32E"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                  fill="#26F32E"
                />
              </svg>
                  <h1>Quality control</h1>
                </div>
              )}
              {pkg.supply_chain_management && (
                <div className="md:flex items-start justify-start px-2">
                 <svg
                className="mr-4"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                  stroke="#26F32E"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                  fill="#26F32E"
                />
              </svg>
                  <h1>Supply chain management</h1>
                </div>
              )}
              {pkg.bill_of_materials && (
                <div className="md:flex items-start justify-start px-2">
                 <svg
                className="mr-4"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                  stroke="#26F32E"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                  fill="#26F32E"
                />
              </svg>
                  <h1>Bill of material</h1>
                </div>
              )}
              {pkg.warehouse_management && (
                <div className="md:flex items-start justify-start px-2">
                  <svg
                className="mr-4"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                  stroke="#26F32E"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                  fill="#26F32E"
                />
              </svg>
                  <h1>Warehouse management</h1>
                </div>
              )}
              {pkg.warehouse_design && (
                <div className="md:flex items-start justify-start px-2">
                 <svg
                className="mr-4"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                  stroke="#26F32E"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                  fill="#26F32E"
                />
              </svg>
                  <h1>Warehouse design</h1>
                </div>
              )}
              {pkg.tracking && (
                <div className="md:flex items-start justify-start px-2">
                  <svg
                className="mr-4"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                  stroke="#26F32E"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                  fill="#26F32E"
                />
              </svg>
                  <h1>Tracking</h1>
                </div>
              )}
              {pkg.chat_support && (
                <div className="md:flex items-start justify-start px-2">
                  <svg
                className="mr-4"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                  stroke="#26F32E"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                  fill="#26F32E"
                />
              </svg>
                  <h1>Chat support</h1>
                </div>
              )}
              {pkg.plan_of_action_provided && (
                <div className="md:flex items-start justify-start px-2">
                  <svg
                className="mr-4"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                  stroke="#26F32E"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                  fill="#26F32E"
                />
              </svg>
                  <h1>Plan of action provided</h1>
                </div>
              )}
              {pkg.call_support && (
                <div className="md:flex items-start justify-start px-2">
                 <svg
                className="mr-4"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                  stroke="#26F32E"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                  fill="#26F32E"
                />
              </svg>
                  <h1>Call support</h1>
                </div>
              )}
              {pkg.installation_support && (
                <div className="md:flex items-start justify-start px-2">
                 <svg
                className="mr-4"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                  stroke="#26F32E"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                  fill="#26F32E"
                />
              </svg>
                  <h1>Installation support by our team</h1>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Pricing;
